import React from 'react';
import '../applications-css/Application.css'
import "../applications-css/PopupWindow.css";

class PopupWindow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.propMethod = this.props.propMethod.bind(this);
  }
  render() {
    return(
      <div id="popupWindowWrapper">
        {this.propMethod()}
        <button onClick = {e => this.props.appExitHandler(e, this.props.appIndex)}> OK </button>
      </div>
    )
  }
}

export default PopupWindow;
